import React from 'react';
export function Agenda() {
  const schedule = [{
    time: '8:00 AM - 9:00 AM',
    title: 'Registration & Breakfast',
    description: 'Networking opportunity with coffee and gourmet breakfast'
  }, {
    time: '9:00 AM - 9:15 AM',
    title: 'Welcome Address',
    description: "Opening remarks and introduction to the day's agenda"
  }, {
    time: '9:15 AM - 10:30 AM',
    title: 'AI in Finance: Practical Applications',
    description: 'Panel discussion with industry leaders on implementing AI solutions'
  }, {
    time: '10:30 AM - 10:45 AM',
    title: 'Networking Break',
    description: 'Refreshments and networking opportunity'
  }, {
    time: '10:45 AM - 12:00 PM',
    title: 'Strategic Planning for 2026',
    description: 'Interactive workshop on long-term financial planning'
  }, {
    time: '12:00 PM - 1:00 PM',
    title: 'Lunch',
    description: 'Gourmet lunch with roundtable discussions'
  }, {
    time: '1:00 PM - 2:30 PM',
    title: 'Porsche Driving Experience',
    description: 'On-track driving sessions with professional instructors'
  }];
  return <section id="agenda" className="py-20 bg-gray-50" data-id="element-31">
      <div className="container mx-auto px-4 md:px-6" data-id="element-32">
        <div className="text-center mb-16" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-34">
            Event Agenda
          </h2>
          <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-35"></div>
          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-36">
            A full day of insights, discussions, and exhilarating experiences
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-37">
          <div className="space-y-8" data-id="element-38">
            {schedule.map((item, index) => <div key={index} className="flex flex-col md:flex-row gap-6 p-6 bg-white rounded-lg shadow-sm" data-id="element-39">
                <div className="md:w-1/3" data-id="element-40">
                  <span className="font-semibold text-red-600" data-id="element-41">
                    {item.time}
                  </span>
                </div>
                <div className="md:w-2/3" data-id="element-42">
                  <h3 className="text-xl font-semibold mb-2" data-id="element-43">{item.title}</h3>
                  <p className="text-gray-600" data-id="element-44">{item.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}